module.exports = __webpack_public_path__ + "static/ladeinde-7b9163d319756a1e68132de7f597a333.jpg";